// import {
//   FORM_ADD_TAG,
//   FORM_ADD_TAGS,
//   FORM_CLEAR_FIELD,
//   FORM_DELETE_TAG,
//   FORM_DELETE_TAGS,
//   FORM_ERROR,
//   FORM_HAS_COMPLETED,
//   FORM_INIT,
//   FORM_RESET,
//   FORM_SUBMIT,
//   FORM_SUBMIT_CLEAR,
//   FORM_SUBMIT_COMPLETE,
//   FORM_UPDATE,
//   FORM_UPDATE_TAG,
//   FORM_OPTIONS_COMPLETE,
//   FORM_OPTIONS_UPDATE,
// } from 'constants/actions'

export const FORM_ADD_TAG = 'FORM_ADD_TAG'
export const FORM_ADD_TAGS = 'FORM_ADD_TAGS'
export const FORM_CLEAR_FIELD = 'FORM_CLEAR_FIELD'
export const FORM_DELETE_TAG = 'FORM_DELETE_TAG'
export const FORM_DELETE_TAGS = 'FORM_DELETE_TAGS'
export const FORM_ERROR = 'FORM_ERROR'
export const FORM_HAS_COMPLETED = 'FORM_HAS_COMPLETED'
export const FORM_INIT = 'FORM_INIT'
export const FORM_RESET = 'FORM_RESET'
export const FORM_SUBMIT = 'FORM_SUBMIT'
export const FORM_SUBMIT_CLEAR = 'FORM_SUBMIT_CLEAR'
export const FORM_SUBMIT_COMPLETE = 'FORM_SUBMIT_COMPLETE'
export const FORM_UPDATE = 'FORM_UPDATE'
export const FORM_UPDATE_TAG = 'FORM_UPDATE_TAG'
export const FORM_OPTIONS_COMPLETE = 'FORM_OPTIONS_COMPLETE'
export const FORM_OPTIONS_UPDATE = 'FORM_OPTIONS_UPDATE'

export const formInit = (formName, formData) => ({
  type: FORM_INIT,
  formName,
  formData,
})

export const formClearField = (formName, fieldName) => ({
  type: FORM_CLEAR_FIELD,
  formName,
  fieldName,
})

export const formUpdate = (formName, formData) => ({
  type: FORM_UPDATE,
  formName,
  formData,
})

export const formError = (formName, errors) => ({
  type: FORM_ERROR,
  formName,
  errors,
})

export const formSubmit = formName => ({
  type: FORM_SUBMIT,
  formName,
})

export const formHasCompleted = formName => ({
  type: FORM_HAS_COMPLETED,
  formName,
})

export const formSubmitComplete = formName => ({
  type: FORM_SUBMIT_COMPLETE,
  formName,
})

export const formSubmitClear = formName => ({
  type: FORM_SUBMIT_CLEAR,
  formName,
})

export const formReset = (formName, truthyFlag = false, specialKey = null) => ({
  type: FORM_RESET,
  formName,
  truthyFlag, // @TODO Find a better way to do this (Re: CreateConversation)
  specialKey,
})

export const formAddTag = (formName, formData) => ({
  type: FORM_ADD_TAG,
  formName,
  formData,
})

export const formOptionsUpdate = (formName, fieldName) => ({
  type: FORM_OPTIONS_UPDATE,
  formName,
  fieldName,
})

export const formOptionsComplete = (formName, fieldName, options, query) => ({
  type: FORM_OPTIONS_COMPLETE,
  formName,
  fieldName,
  options,
  lastQuery: query,
})

export const formAddTags = (formName, fieldName, tags) => ({
  type: FORM_ADD_TAGS,
  formName,
  fieldName,
  tags,
})

export const formUpdateTag = (formName, fieldName, index, label) => ({
  type: FORM_UPDATE_TAG,
  formName,
  fieldName,
  index,
  label,
})

export const formDeleteTag = (formName, fieldName, index) => ({
  type: FORM_DELETE_TAG,
  formName,
  fieldName,
  index,
})

export const formDeleteTags = (formName, fieldName, tags) => ({
  type: FORM_DELETE_TAGS,
  formName,
  fieldName,
  tags,
})

export function formComplete(formName) {
  return (dispatch) => {
    dispatch(formSubmitComplete(formName))

    setTimeout(() => {
      dispatch(formHasCompleted(formName))
    }, 2000)

    setTimeout(() => {
      dispatch(formSubmitClear(formName))
    }, 8000)
  }
}

export function getFormOptions(formName, fieldName, query, request) {
  console.log('[actions/forms.js:getFormOptions()] => ', request) // eslint-disable-line no-console

  return (dispatch) => {
    dispatch(formOptionsUpdate(formName, fieldName))
    dispatch(request(query, (result) => {
      dispatch(formOptionsComplete(formName, fieldName, result, query))
    }))
  }
}



// WEBPACK FOOTER //
// ./src/actions/forms.js